import { render, staticRenderFns } from "./KanbanBoard.vue?vue&type=template&id=7d49470d&scoped=true"
import script from "./KanbanBoard.vue?vue&type=script&lang=js"
export * from "./KanbanBoard.vue?vue&type=script&lang=js"
import style0 from "./KanbanBoard.vue?vue&type=style&index=0&id=7d49470d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d49470d",
  null
  
)

export default component.exports